import React from "react";
import Calendar from "../components/Calendar";
import { getRoutineSchedule } from "../api/routine";

export default class Todo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      today: new Date().getDate(),
      list: [],
    };
  }

  async componentDidMount() {
    await this.loadData();
  }

  async loadData() {
    const items = await getRoutineSchedule();
    this.setState({
      list: items,
    });
  }

  render() {
    return (
      <section>
        To do
        <Calendar
          year={this.state.year}
          month={this.state.month}
          today={this.state.today}
          scheduleList={this.state.list}
        />
      </section>
    );
  }
}
